import { render } from "./OfferPrice.vue?vue&type=template&id=3b1d4c45&scoped=true"
import script from "./OfferPrice.vue?vue&type=script&lang=js"
export * from "./OfferPrice.vue?vue&type=script&lang=js"

import "./OfferPrice.vue?vue&type=style&index=0&id=3b1d4c45&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\hesabtech-live\\hesabtech-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b1d4c45"]])

export default __exports__